import { render, staticRenderFns } from "./Maintext.vue?vue&type=template&id=90224f46&"
import script from "./Maintext.vue?vue&type=script&lang=js&"
export * from "./Maintext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports